import { useEffect, ReactNode } from 'react'
import { useOutletContext } from 'react-router'
import { PageLayoutContext } from 'src/layouts/PageLayout/PageLayout'

export function usePageConfig(pageId: string, headerContent: ReactNode) {
  const { setPageId, setHeaderContent } = useOutletContext<PageLayoutContext>()

  useEffect(() => {
    setPageId(pageId)
    setHeaderContent(headerContent)
    return () => {
      setPageId('')
      setHeaderContent(null)
    }
  }, [pageId, headerContent, setPageId, setHeaderContent])
}
